export const LOAD_CART = "LOAD_CART";
export const ADD_PRODUCT = "ADD_PRODUCT";
export const REMOVE_PRODUCT = "REMOVE_PRODUCT";
export const UPDATE_CART = "UPDATE_CART";
export const GET_SLOTS = "GET_SLOTS";
export const DELIVERY_DATE = "DELIVERY_DATE";
export const DELIVERY_TIME_SLOT = "DELIVERY_TIME_SLOT";
